/* AKTEPELER - SIPARIS KURALI (minimum adet + 250'ser adim)
 *
 * NEDEN AYRI DOSYA: altbilgideki betik adet kutusunu yalniz 'change'
 * olayinda duzeltiyordu. Olculdu (4 Agu 2026): /cart/add.js ile 249 adet
 * sepete HATASIZ girdi ve odemeye kadar hicbir yerde durdurulmadi.
 * Yani kural aliciya "oneriliyor", "zorlanmiyordu".
 *
 * KURAL:
 *   1 adet          -> serbest (NUMUNE yolu; bozulmayacak)
 *   2 - 249         -> 250'ye yukseltilir
 *   250 ve ustu     -> 250'ser adima yuvarlanir
 *
 * IKI KATMAN:
 *   1) Girdi katmani  - adet kutusu yazilirken/degisirken duzeltir.
 *      'change' YETMIYOR: Horizon'un +/- dugmeleri degeri programatik
 *      yazip 'input' firlatiyor, 'change' hic gelmiyor.
 *   2) Sepet katmani  - sepet sayfasinda kurala aykiri satir varsa
 *      odeme butonu kilitlenir ve tek tikla duzeltme sunulur.
 *
 * SINIR: bu istemci tarafi bir kuraldir. /cart/add.js'e dogrudan istek
 * atan bir betigi durdurmaz. Sunucu tarafi zorlama icin Shopify'da
 * "cart/checkout validation function" gerekir; temel pakette yok.
 * Gercek alicinin gectigi her yolu kapatir, otomasyonu kapatmaz.
 */
(function () {
  'use strict';

  var MOQ = 250;
  var ADIM = 250;

  /* Uyari kutusunun stili betikle birlikte geliyor: kural kendi kendine
     yeten tek parca olsun, ayri bir CSS istegi acmayalim. */
  (function stil() {
    if (document.getElementById('akt-moq-stil')) return;
    var s = document.createElement('style');
    s.id = 'akt-moq-stil';
    s.textContent =
      '.akt-moq-uyari{margin:0 0 16px;padding:14px 16px;border-radius:12px;' +
      'background:#FDF4E3;border:1px solid #E4C48A;color:#5A431C;' +
      'font-size:14px;line-height:1.55;display:flex;flex-wrap:wrap;' +
      'align-items:center;gap:10px}' +
      '.akt-moq-uyari strong{color:#3F2F13}' +
      '#akt-moq-duzelt{margin-left:auto;min-height:44px;padding:0 18px;' +
      'border:0;border-radius:999px;background:#1F3A30;color:#F6F4EF;' +
      'font-weight:700;font-size:14px;cursor:pointer}' +
      '#akt-moq-duzelt[disabled]{opacity:.6;cursor:default}' +
      '@media (max-width:600px){#akt-moq-duzelt{margin-left:0;width:100%}}';
    (document.head || document.documentElement).appendChild(s);
  })();

  /* ---------- ortak: bir adedi kurala uydur ---------- */
  function duzelt(v, onceki) {
    v = parseInt(v, 10);
    if (!v || v < 1) return 1;
    if (v === 1) return 1;                    /* numune */
    if (v < MOQ) return MOQ;                  /* 2-249 */
    /* yon farki: artiriyorsa yukari, azaltiyorsa asagi yuvarla */
    var o = (onceki != null && v > onceki)
      ? Math.ceil(v / ADIM) * ADIM
      : Math.floor(v / ADIM) * ADIM;
    return o < MOQ ? MOQ : o;
  }

  /* ---------- 1) girdi katmani ---------- */
  function uygula(i) {
    var onc = parseInt(i.dataset.aktOnceki, 10);
    var yeni = duzelt(i.value, isNaN(onc) ? null : onc);
    if (String(yeni) !== String(i.value)) {
      i.value = yeni;
      /* Horizon'un kendi dinleyicileri haberdar olsun */
      i.dispatchEvent(new Event('input', { bubbles: true }));
      i.dispatchEvent(new Event('change', { bubbles: true }));
    }
    i.dataset.aktOnceki = yeni;
  }

  function adetKutusuMu(e) {
    return e && e.name === 'quantity' && e.tagName === 'INPUT';
  }

  /* change: klavyeyle yazip alandan cikinca */
  document.addEventListener('change', function (e) {
    if (adetKutusuMu(e.target)) uygula(e.target);
  }, true);

  /* input: +/- dugmeleri degeri programatik yaziyor.
     Yaziyor olabilecegi icin hemen degil, bir tik sonra duzelt -
     yoksa kullanici "2" yazarken ilk karakterde 250'ye ziplar. */
  var zaman = null;
  document.addEventListener('input', function (e) {
    if (!adetKutusuMu(e.target)) return;
    var i = e.target;
    clearTimeout(zaman);
    zaman = setTimeout(function () { uygula(i); }, 700);
  }, true);

  /* ---------- STEPPER: +/- 250'ser adim ----------
     ONCEKI HATA: kapsayici `quantity-selector` diye araniyordu ama Horizon'un
     ozel elemani <quantity-selector-component>. closest() bunu ESLESTIRMEZ,
     bu yuzden +/- duzeltmesi hic calismiyordu ve dugmeler 1'er artiriyordu.

     Artik dugmenin kendisinden yukari dogru adet kutusu araniyor - eleman
     adindan bagimsiz, Horizon yapiyi degistirse de tutar. */
  function kutuBul(b) {
    var kap = b.closest(
      'quantity-selector-component, cart-quantity-selector-component,' +
      '[ref="quantitySelector"], .quantity-selector, [class*="quantity"]'
    );
    if (kap) {
      var i = kap.querySelector('input[name="quantity"]');
      if (i) return i;
    }
    /* son care: en fazla 4 ata yukari cik */
    var p = b.parentElement, n = 0;
    while (p && n < 4) {
      var x = p.querySelector('input[name="quantity"]');
      if (x) return x;
      p = p.parentElement; n++;
    }
    return null;
  }

  function yon(b) {
    var r = (b.getAttribute('ref') || '') + ' ' +
            (b.getAttribute('aria-label') || '') + ' ' +
            (b.className || '') + ' ' + (b.textContent || '');
    if (/plus|increase|artır|artir|\+/i.test(r)) return 1;
    if (/minus|decrease|azalt|−|–|-/.test(r)) return -1;
    return 0;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button');
    if (!b) return;
    var i = kutuBul(b);
    if (!i) return;
    var d = yon(b);
    if (!d) return;

    var sepetMi = /\/cart/.test(window.location.pathname);
    var v = parseInt(i.value, 10) || 0;
    var y;

    if (d > 0) {
      /* 0 veya 1 (numune) -> ilk kademe; sonrasi bir sonraki 250 kati */
      y = v < MOQ ? MOQ : Math.floor(v / ADIM) * ADIM + ADIM;
    } else {
      if (v > MOQ) y = Math.ceil(v / ADIM) * ADIM - ADIM;   /* 500->250, 252->250 */
      else if (v > 1) y = 1;                                 /* 250 -> numune */
      else y = sepetMi ? 0 : 1;                              /* sepette 0 = satir sil */
      if (y < 0) y = 0;
    }

    if (y === v) return;

    /* Horizon'un kendi ±1 mantigi calismasin */
    e.preventDefault();
    e.stopPropagation();

    i.value = y;
    i.dataset.aktOnceki = y;
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  /* ---------- 1b) VARSAYILAN ADET ----------
     Horizon adet kutusunu value="1" ile basiyor. MOQ 250 olan bir sitede
     alici urun sayfasina girip dogrudan "Sepete ekle"ye bastiginda 1 adet
     ekleniyordu. Varsayilani MOQ yapiyoruz; numune isteyen 1 yazar.
     Sepet sayfasindaki kutulara DOKUNULMAZ - orada gercek satir adedi var. */
  function varsayilan() {
    if (/\/cart/.test(window.location.pathname)) return;
    if (!/\/products\//.test(window.location.pathname)) return;
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      if (i.dataset.aktVars) return;
      i.dataset.aktVars = '1';
      var v = parseInt(i.value, 10);
      if (!v || v === 1) {
        i.value = MOQ;
        i.dataset.aktOnceki = MOQ;
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---------- 1c) SEPETE EKLEME ANINDA SON KONTROL ----------
     En kritik katman. Girdi katmani yarisa girebiliyor (Horizon adedi
     on:blur="/setQuantity" ile isliyor, benim change dinleyicimle cakisiyor).
     Burada islem TAMAMLANMADAN once deger duzeltiliyor.

     Iki yol da kapatiliyor:
       a) klasik form gonderimi  -> submit yakalanir
       b) Horizon'un AJAX cagrisi -> fetch sarmalanir
     Ikisi de 1 adedi (numune) serbest birakir. */

  function uyar(mesaj) {
    var id = 'akt-ekle-uyari';
    var v = document.getElementById(id);
    if (!v) {
      v = document.createElement('div');
      v.id = id;
      v.className = 'akt-moq-uyari';
      var f = document.querySelector('form[action*="/cart/add"]');
      if (f && f.parentNode) f.parentNode.insertBefore(v, f);
      else return;
    }
    v.innerHTML = '<strong>Minimum sipariş 250 adet.</strong> ' + mesaj;
    clearTimeout(uyar._z);
    uyar._z = setTimeout(function () { if (v) v.remove(); }, 6000);
  }

  /* a) form gonderimi */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') < 0) return;
    var i = f.querySelector('input[name="quantity"]');
    if (!i) return;
    var v = parseInt(i.value, 10) || 1;
    if (v === 1 || v >= MOQ) return;          /* numune veya kurala uygun */
    var o = duzelt(v, 1);
    i.value = o;
    i.dataset.aktOnceki = o;
    uyar('Adet ' + v + ' yerine ' + o + ' olarak eklendi. Numune için 1 yazın.');
  }, true);

  /* b) AJAX - hem EKLEME hem SEPETTE ADET DEGISTIRME
     Olculdu (4 Agu 2026): Horizon sepette Theme.routes.cart_change_url'i,
     yani "/cart/change" (uzantisiz) cagiriyor. Onceki surum yalniz
     "/cart/add" yakaliyordu; bu yuzden sepette 251 ve 499 takili kaliyordu.

     Sepette 0 SERBEST birakilir - satir silme oyle yapiliyor.
     1 de serbest (numune). 2-249 -> 250. 250 ustu 250'ser adima yuvarlanir. */

  function sepettekiAdet(q, sepetMi) {
    q = parseInt(q, 10);
    if (isNaN(q)) return null;
    if (sepetMi && q === 0) return null;      /* satir silme - dokunma */
    if (q === 1) return null;                 /* numune */
    var o = duzelt(q, 1);
    return o === q ? null : o;                /* degisiklik yoksa null */
  }

  var asilFetch = window.fetch;
  window.fetch = function (girdi, ayar) {
    try {
      var url = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || '';
      var ekleme = url.indexOf('/cart/add') >= 0;
      var degistirme = url.indexOf('/cart/change') >= 0 || url.indexOf('/cart/update') >= 0;

      if ((ekleme || degistirme) && ayar && ayar.body) {
        ayar = Object.assign({}, ayar);
        var sepetMi = degistirme;
        var duzeltildi = null;

        if (typeof ayar.body === 'string' && ayar.body.charAt(0) === '{') {
          var j = JSON.parse(ayar.body);

          /* sekil 1: { line, quantity }  — Horizon'un adet degistirmesi */
          if (j && j.quantity != null) {
            var y = sepettekiAdet(j.quantity, sepetMi);
            if (y != null) { duzeltildi = [j.quantity, y]; j.quantity = y; }
          }
          /* sekil 2: { lines: [{ id, quantity }] } — Cart API surumu */
          if (j && Array.isArray(j.lines)) {
            j.lines.forEach(function (s) {
              var y2 = sepettekiAdet(s.quantity, sepetMi);
              if (y2 != null) { duzeltildi = [s.quantity, y2]; s.quantity = y2; }
            });
          }
          /* sekil 3: { updates: { varyantId: adet } } — toplu guncelleme */
          if (j && j.updates && typeof j.updates === 'object') {
            Object.keys(j.updates).forEach(function (k) {
              var y3 = sepettekiAdet(j.updates[k], sepetMi);
              if (y3 != null) { duzeltildi = [j.updates[k], y3]; j.updates[k] = y3; }
            });
          }
          if (duzeltildi) ayar.body = JSON.stringify(j);

        } else if (typeof URLSearchParams !== 'undefined' &&
                   ayar.body instanceof URLSearchParams) {
          var q2 = sepettekiAdet(ayar.body.get('quantity'), sepetMi);
          if (q2 != null) {
            duzeltildi = [ayar.body.get('quantity'), q2];
            ayar.body.set('quantity', String(q2));
          }
        } else if (typeof FormData !== 'undefined' && ayar.body instanceof FormData) {
          var q3 = sepettekiAdet(ayar.body.get('quantity'), sepetMi);
          if (q3 != null) {
            duzeltildi = [ayar.body.get('quantity'), q3];
            ayar.body.set('quantity', String(q3));
          }
        }

        if (duzeltildi) {
          uyar('Adet ' + duzeltildi[0] + ' yerine ' + duzeltildi[1] +
               ' olarak ayarlandı. Sipariş 250’şer artar; numune için 1 yazın.');
        }
      }
    } catch (e) { /* sarmalayici asla islemi engellemesin */ }
    return asilFetch.apply(this, [girdi, ayar]);
  };

  /* c) Sepetteki adet kutusu: Horizon degeri kendi olayiyla isliyor.
     Kutu degistiginde de kurala uydur ki ekranda yanlis rakam kalmasin. */
  document.addEventListener('input', function (e) {
    if (!adetKutusuMu(e.target)) return;
    if (!/\/cart/.test(window.location.pathname)) return;
    var i = e.target;
    clearTimeout(i._aktZ);
    i._aktZ = setTimeout(function () {
      var y = sepettekiAdet(i.value, true);
      if (y != null) {
        i.value = y;
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 800);
  }, true);

  /* ---------- 2) sepet katmani ---------- */
  function sepetSayfasiMi() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function odemeButonlari() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout-button')
    );
  }

  function uyariGoster(bozuk) {
    var id = 'akt-moq-uyari';
    var v = document.getElementById(id);
    if (!v) {
      v = document.createElement('div');
      v.id = id;
      v.className = 'akt-moq-uyari';
      var hedef = document.querySelector('.cart__footer, .cart-items, main') || document.body;
      hedef.insertBefore(v, hedef.firstChild);
    }
    v.innerHTML =
      '<strong>Minimum sipariş 250 adet.</strong> ' +
      'Sepetinizde bu kuralın altında ' + bozuk.length + ' satır var. ' +
      'Numune istiyorsanız adet 1 olmalıdır. ' +
      '<button type="button" id="akt-moq-duzelt">Adetleri düzelt</button>';

    var d = document.getElementById('akt-moq-duzelt');
    if (d) d.addEventListener('click', function () {
      d.disabled = true;
      d.textContent = 'Düzeltiliyor...';
      var zincir = Promise.resolve();
      bozuk.forEach(function (s) {
        zincir = zincir.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: s.satir, quantity: MOQ })
          });
        });
      });
      zincir.then(function () { window.location.reload(); });
    }, { once: true });
  }

  function uyariGizle() {
    var v = document.getElementById('akt-moq-uyari');
    if (v) v.remove();
  }

  function sepetDenetle() {
    if (!sepetSayfasiMi() && !document.querySelector('cart-drawer-component')) return;
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var bozuk = [];
        (c.items || []).forEach(function (it, n) {
          /* 1 adet serbest (numune). 2-249 kurala aykiri. */
          if (it.quantity > 1 && it.quantity < MOQ) bozuk.push({ satir: n + 1, adet: it.quantity });
        });
        var btn = odemeButonlari();
        if (bozuk.length) {
          uyariGoster(bozuk);
          btn.forEach(function (b) {
            b.disabled = true;
            b.setAttribute('aria-disabled', 'true');
            b.dataset.aktKilit = '1';
          });
        } else {
          uyariGizle();
          btn.forEach(function (b) {
            if (b.dataset.aktKilit) {
              b.disabled = false;
              b.removeAttribute('aria-disabled');
              delete b.dataset.aktKilit;
            }
          });
        }
      })
      .catch(function () { /* ag hatasi odemeyi kilitlemesin */ });
  }

  function kur() {
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      if (!i.dataset.aktOnceki) i.dataset.aktOnceki = i.value;
    });
    varsayilan();
    sepetDenetle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur, { once: true });
  } else {
    kur();
  }
  /* Horizon sepeti AJAX ile guncelliyor; degisiklikten sonra tekrar denetle. */
  document.addEventListener('cart:updated', sepetDenetle);
  document.addEventListener('cart:refresh', sepetDenetle);

  /* Varyant degisince Horizon adet kutusunu YENIDEN basiyor ve value 1'e
     donuyor. Kare basina tek tarama; kendi yazdiklarimiz tetiklemesin diye
     gozlem sirasinda durduruluyor. */
  if (typeof MutationObserver !== 'undefined') {
    var bekleyen = false;
    var g = new MutationObserver(function () {
      if (bekleyen) return;
      bekleyen = true;
      requestAnimationFrame(function () {
        bekleyen = false;
        g.disconnect();
        varsayilan();
        g.observe(document.body, { childList: true, subtree: true });
      });
    });
    if (document.body) g.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function () {
      g.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }
})();
